// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailInputActions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var AddUserPopup = require('modules/User/Izenda.AddUserPopup');
  var ACCESS_CONSTANT = require('logic/data/Izenda.AccessConstants');

  const { curry, toLower, split } = require('lodash/fp');

  var emailInputActions = compose(
    withHandlers({
      openPopupAddUserPopup: curry(openPopupAddUserPopup)
    })
  );

  /**
   * Open add user popup
   * @param {Object} props
   */
  function openPopupAddUserPopup(props, e) {
    const selectedEmails = props.email[toLower(props.label)];
    props.openPopup(AddUserPopup, {
      onChange: props.addRecipientsFromPopup,
      selectedItems: selectedEmails ? split(';', selectedEmails).map(item => ({ email: item })) : [],
      userModeType: ACCESS_CONSTANT.USER_ACCESS_MODE.SCHEDULE,
      validateEmails: true
    });
  }

  module.exports = emailInputActions;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/CommonPopup/Izenda.EmailInputActions.js